import { calcLineItemTotals } from "../proposalUtils";
import { lineBadges } from "../grid/gridMath";
import { findLibraryPart, libraryChanges } from "../grid/libraryDiff";

// Same math as the internal Project Summary total row: tax is a pass-through on both sides, GM% against pre-tax revenue.
export const grossMargin = (t) => {
  const tax = t.taxAmount || 0;
  const cost = t.costMaterial + t.costEquipment + t.costFreight + t.costLabor + t.costTravel + t.costDisposal + (t.costSubcontract || 0) + tax;
  const amount = t.total - cost;
  const pre = t.total - tax;
  return { amount, pct: pre > 0 ? (amount / pre) * 100 : null };
};

export const railWarnings = (scopes, masterParts, reviewable) => {
  let quote = 0, review = 0;
  (scopes || []).forEach((s) => (s.line_items || []).forEach((li) => {
    if (lineBadges(li, calcLineItemTotals(li)).includes("Quote")) quote++;
    if (reviewable && libraryChanges(li, findLibraryPart(li, masterParts)).length) review++;
  }));
  return { quote, review };
};

export const marginLines = (scopes) => (scopes || []).reduce((a, s) => a + (s.line_items || []).filter((li) => !li.wc_key).length, 0);

export const taxHint = (breakdown) => {
  if (!breakdown || typeof breakdown !== "object") return "";
  return Object.values(breakdown).filter(Boolean).join(" · ");
};
